<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">
    Table of Contents
  </div>
<div>
     <br/>
</div>
<div class="cfmh">
<a href="#/Text/clau_9780738214993_oeb_fm1_r1">Praise</a>
</div>
<div class="cfmh">
<span href="#/Text/clau_9780738214993_oeb_tp_r1" title="Link target outside of Sample">Title Page</span>
</div>
<div class="cfmh">
<a href="#/Text/clau_9780738214993_oeb_ded_r1">Dedication</a>
</div>
<div class="cfmh">
<a href="#/Text/clau_9780738214993_oeb_prf_r1">Preface</a>
</div>
<div class="cct">
<a href="#/Text/clau_9780738214993_oeb_c01_r1">Chapter 1 - The Stress Epidemic</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c01_r1#h1">How Did We Get into This Situation?</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c01_r1#h2">Are We Talking About You?</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c01_r1#h3">How to Change Course</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c01_r1#h4">The Theory Behind the Stress Epidemic and This Book</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c01_r1#h5">How This Book Works</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c01_r1#h6">Take-Home Messages from This Chapter</a>
</div>
<div>
     <br/>
</div>
<div class="cpt">
<a href="#/Text/clau_9780738214993_oeb_p01_r1">PART I - DUALITY</a>
</div>
<div class="cct">
<a href="#/Text/clau_9780738214993_oeb_c02_r1">Chapter 2 - Hormones</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c02_r1#h1">Yin and Yang</a>
</div>
<div class="cct">
<a href="#/Text/clau_9780738214993_oeb_c03_r1">Chapter 3 - Sex Hormones</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c03_r1#h1">Estrogen: Yin Within Yin</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c03_r1#h2">Progesterone: Yang Within Yin</a>
</div>
<div class="cct">
<a href="#/Text/clau_9780738214993_oeb_c04_r1">Chapter 4 - Stress Hormones</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c04_r1#h1">Cortisol: Yang Within Yang</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c04_r1#h2">DHEA: Yin Within Yang</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c04_r1#h3">Oxytocin and Prolactin: Bonus Buffers</a>
</div>
<div class="cct">
<a href="#/Text/clau_9780738214993_oeb_c05_r1">Chapter 5 - Understanding How Yin and Yang Hormones Interact</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c05_r1#h1">Survival Always Comes First</a>
</div>
<div class="ch1">
<a href="#/Text/clau_9780738214993_oeb_c05_r1#h2">Nature’s Good Intentions for Us</a>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c06_r1" title="Link target outside of Sample">Chapter 6 - Why Not Just Take HRT/Synthetic or Bioidentical Hormones?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c06_r1#h1" title="Link target outside of Sample">Synthetic Hormones</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c06_r1#h2" title="Link target outside of Sample">Bioidentical Hormones</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c06_r1#h3" title="Link target outside of Sample">Take-Home Messages from Part I</span>
</div>
<div>
     <br/>
</div>
<div class="cpt">
<span href="#/Text/clau_9780738214993_oeb_p02_r1" title="Link target outside of Sample">PART II - WOMEN’S HEALTH CONCERNS</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c07_r1" title="Link target outside of Sample">Chapter 7 - Women’s Health Concerns</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c08_r1" title="Link target outside of Sample">Chapter 8 - Feeling Crummy</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c08_r1#h1" title="Link target outside of Sample">What Does Eastern Medicine Do About “Feeling Crummy”?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c08_r1#h2" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c09_r1" title="Link target outside of Sample">Chapter 9 - Menstruation</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c09_r1#h1" title="Link target outside of Sample">Why We Have Cycles</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c09_r1#h2" title="Link target outside of Sample">Eliminating Cycles</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c09_r1#h3" title="Link target outside of Sample">What Does Eastern Medicine Do About Menstruation?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c09_r1#h4" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c10_r1" title="Link target outside of Sample">Chapter 10 - Menstrual Difficulties</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h1" title="Link target outside of Sample">Scanty or Absent Periods</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h2" title="Link target outside of Sample">What Does Eastern Medicine Do About Scanty or Absent Periods?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h3" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h4" title="Link target outside of Sample">Heavy or Painful Periods</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h5" title="Link target outside of Sample">What Does Eastern Medicine Do About Heavy Bleeding or Painful Periods?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h6" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h7" title="Link target outside of Sample">Irregular or Missed Cycles</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h8" title="Link target outside of Sample">What Does Eastern Medicine Do About Irregular or Missed Cycles?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c10_r1#h9" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c11_r1" title="Link target outside of Sample">Chapter 11 - Birth Control</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c11_r1#h1" title="Link target outside of Sample">Historical and Current Practices</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c11_r1#h2" title="Link target outside of Sample">What Does Eastern Medicine Do About Birth Control?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c11_r1#h3" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c12_r1" title="Link target outside of Sample">Chapter 12 - Fertility and Conception</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c12_r1#h1" title="Link target outside of Sample">The Egg</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c12_r1#h2" title="Link target outside of Sample">The Sperm</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c12_r1#h3" title="Link target outside of Sample">The Reproductive System</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c12_r1#h4" title="Link target outside of Sample">Timing of Conception</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c12_r1#h5" title="Link target outside of Sample">What Does Eastern Medicine Do About Conception?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c12_r1#h6" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c13_r1" title="Link target outside of Sample">Chapter 13 - Breast Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c13_r1#h1" title="Link target outside of Sample">Considering the Known Risk Factors</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c13_r1#h2" title="Link target outside of Sample">Synthetic Hormones and Breast Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c13_r1#h3" title="Link target outside of Sample">What Does Eastern Medicine Do for Breast Health?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c13_r1#h4" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c14_r1" title="Link target outside of Sample">Chapter 14 - Perimenopause and Menopause</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c14_r1#h1" title="Link target outside of Sample">Perimenopause and Menopause: From Brawn to Brains</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c14_r1#h2" title="Link target outside of Sample">Synthetic Hormone Replacement Therapy</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c14_r1#h3" title="Link target outside of Sample">Bioidentical Hormone Replacement Therapy</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c14_r1#h4" title="Link target outside of Sample">What Does Eastern Medicine Do for Perimenopause and Menopause?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c14_r1#h5" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c15_r1" title="Link target outside of Sample">Chapter 15 - Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h1" title="Link target outside of Sample">Women’s Heart Health vs. Men’s Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h2" title="Link target outside of Sample">Inflammation and Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h3" title="Link target outside of Sample">Diet,Walking, Stretching, and Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h4" title="Link target outside of Sample">Smoking and Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h5" title="Link target outside of Sample">Emotions and Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h6" title="Link target outside of Sample">Synthetic Hormones and Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h7" title="Link target outside of Sample">Alcohol and Heart Health</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h8" title="Link target outside of Sample">What Does Eastern Medicine Do for Heart Health?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c15_r1#h9" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c16_r1" title="Link target outside of Sample">Chapter 16 - Osteoporosis</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h1" title="Link target outside of Sample">Bone Quantity and Quality</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h2" title="Link target outside of Sample">Hormones and Bone Loss</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h3" title="Link target outside of Sample">Calcium, Diet, and Exercise</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h4" title="Link target outside of Sample">Breastfeeding</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h5" title="Link target outside of Sample">Antidepressants</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h6" title="Link target outside of Sample">Osteoporosis Drugs</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h7" title="Link target outside of Sample">What Does Eastern Medicine Do About Osteoporosis?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c16_r1#h8" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c17_r1" title="Link target outside of Sample">Chapter 17 - Alzheimer’s Disease and Dementia</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c17_r1#h1" title="Link target outside of Sample">What Does Eastern Medicine Do for Alzheimer’s and Dementia?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c17_r1#h2" title="Link target outside of Sample">What Should I Do?</span>
</div>
<div>
     <br/>
</div>
<div class="cpt">
<span href="#/Text/clau_9780738214993_oeb_p03_r1" title="Link target outside of Sample">PART III - USING THE THREE PILLARS OF HEALTH TO RESTORE HORMONAL BALANCE</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c18_r1" title="Link target outside of Sample">Chapter 18 - The Importance of Diet and Lifestyle</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c18_r1#h1" title="Link target outside of Sample">Disease Care vs. Disease Prevention</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c18_r1#h2" title="Link target outside of Sample">Awareness</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c18_r1#h3" title="Link target outside of Sample">Three Steps to Get Started</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c19_r1" title="Link target outside of Sample">Chapter 19 - Quality and Quantity of Food</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c19_r1#h1" title="Link target outside of Sample">Quality</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c19_r1#h2" title="Link target outside of Sample">Quantity</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c20_r1" title="Link target outside of Sample">Chapter 20 - Food, Medicine, and Poison</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c20_r1#h1" title="Link target outside of Sample">Ama, or Toxic Sludge</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c20_r1#h2" title="Link target outside of Sample">Eat in a Calm Mood and Environment</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c20_r1#h3" title="Link target outside of Sample">How to Reduce Food Intolerance</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c20_r1#h4" title="Link target outside of Sample">Cravings and Choices</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c21_r1" title="Link target outside of Sample">Chapter 21 - What to Eat</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c21_r1#h1" title="Link target outside of Sample">Whole Foods</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c21_r1#h2" title="Link target outside of Sample">What to Eat in Times of Stress</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c22_r1" title="Link target outside of Sample">Chapter 22 - Meat</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c22_r1#h1" title="Link target outside of Sample">Building Blood and Strength</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c22_r1#h2" title="Link target outside of Sample">Belief Systems</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c22_r1#h3" title="Link target outside of Sample">Other Considerations</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c23_r1" title="Link target outside of Sample">Chapter 23 - What Not to Eat</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c23_r1#h1" title="Link target outside of Sample">Fast or Highly Processed Food</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c23_r1#h2" title="Link target outside of Sample">Alcohol</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c23_r1#h3" title="Link target outside of Sample">Cola</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c23_r1#h4" title="Link target outside of Sample">Foods Treated with Pesticides and Chemicals</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c24_r1" title="Link target outside of Sample">Chapter 24 - The Pros and Cons of Soy</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c24_r1#h1" title="Link target outside of Sample">The “Bad Soy” Camp</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c24_r1#h2" title="Link target outside of Sample">The “Good Soy” Camp</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c24_r1#h3" title="Link target outside of Sample">Soy: Meeting in the Middle</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c24_r1#h4" title="Link target outside of Sample">What Does Eastern Medicine Say About Soy?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c24_r1#h5" title="Link target outside of Sample">Some Conclusions About Phytoestrogens</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c25_r1" title="Link target outside of Sample">Chapter 25 - Essential Elements of a Healthy Lifestyle</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h1" title="Link target outside of Sample">Trapped on the Modern Treadmill</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h2" title="Link target outside of Sample">The Good News (Yes,There Is Some!)</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h3" title="Link target outside of Sample">Relaxing into a Routine</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h4" title="Link target outside of Sample">Exercise</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h5" title="Link target outside of Sample">Sleep</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h6" title="Link target outside of Sample">Relationships</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c25_r1#h7" title="Link target outside of Sample">Environment</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c26_r1" title="Link target outside of Sample">Chapter 26 - Stress Management Techniques</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c26_r1#h1" title="Link target outside of Sample">Stress and Its Causes</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c26_r1#h2" title="Link target outside of Sample">First Things First</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c26_r1#h3" title="Link target outside of Sample">Spiritual Practices and Meditation</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c26_r1#h4" title="Link target outside of Sample">Abhyanga: Warm Oil Self-Massage</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c26_r1#h5" title="Link target outside of Sample">Pranayama and Alternate-Nostril Breathing</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c26_r1#h6" title="Link target outside of Sample">Laughter</span>
</div>
<div class="cct">
<span href="#/Text/clau_9780738214993_oeb_c27_r1" title="Link target outside of Sample">Chapter 27 - Changing Lifestyles, Changing Lives</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h1" title="Link target outside of Sample">Hope</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h2" title="Link target outside of Sample">Take Away Everything That Isn’t Horse</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h3" title="Link target outside of Sample">Sacrifice Ambition at the Altar of Reality</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h4" title="Link target outside of Sample">Surrender to the Pace of Your Body</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h5" title="Link target outside of Sample">Making Choices</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h6" title="Link target outside of Sample">Self-Blame vs. Self-Responsibility</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h7" title="Link target outside of Sample">Nature Throws Us Curve Balls</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h8" title="Link target outside of Sample">How Long Does It Take to See Change?</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h9" title="Link target outside of Sample">The Three-Tier Treatment Strategy Revisited</span>
</div>
<div class="ch1">
<span href="#/Text/clau_9780738214993_oeb_c27_r1#h10" title="Link target outside of Sample">Take-Home Messages from Part III</span>
</div>
<div>
     <br/>
</div>
<div class="apt">
<span href="#/Text/clau_9780738214993_oeb_ap1_r1" title="Link target outside of Sample">APPENDIX A - RESOURCES</span>
</div>
<div class="apt">
<span href="#/Text/clau_9780738214993_oeb_ap2_r1" title="Link target outside of Sample">APPENDIX B - AN INTRODUCTION TO AYURVEDA AND TRADITIONAL CHINESE MEDICINE (TCM)</span>
</div>
<div class="apt">
<span href="#/Text/clau_9780738214993_oeb_ap3_r1" title="Link target outside of Sample">APPENDIX C - ABHYANGA, OR AYURVEDIC WARM-OIL MASSAGE</span>
</div>
<div class="apt">
<span href="#/Text/clau_9780738214993_oeb_ap4_r1" title="Link target outside of Sample">APPENDIX D - HOW TO MAKE KITCHERI AND GHEE</span>
</div>
<div class="apt">
<span href="#/Text/clau_9780738214993_oeb_ap5_r1" title="Link target outside of Sample">APPENDIX E - CASTOR OIL PACKS FOR UTERINE HEALTH</span>
</div>
<div class="apt">
<span href="#/Text/clau_9780738214993_oeb_ap6_r1" title="Link target outside of Sample">APPENDIX F - FOOD GLOSSARY</span>
</div>
<div class="cbmh">
<span href="#/Text/clau_9780738214993_oeb_ack_r1" title="Link target outside of Sample">Acknowledgements</span>
</div>
<div class="cbmh" id="toc-discover-page"><a href="#/Text/discoverpage">Discover More</a></div>
<div class="cbmh">
<span href="#/Text/clau_9780738214993_oeb_nts_r1" title="Link target outside of Sample">NOTES</span>
</div>
<div class="cbmh">
<span href="#/Text/clau_9780738214993_oeb_in1_r1" title="Link target outside of Sample">INDEX</span>
</div>
<div class="cbmh">
<span href="#/Text/clau_9780738214993_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// clau_9780738214993_oeb_toc_r1.vue?bf943fba